var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegalPage',{attrs:{"title":"Disclaimer","subtitle":"Information and risk notice","intro":"The content on gbmodshub.net is published for general information only. It is not legal, technical, or security advice.","sections":_vm.sections,"email":"contact@gbmodshub.net","page-name":"disclaimer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }